export default {"src":"/_next/static/media/pdf-file.d3086999.svg","height":50,"width":38,"blurWidth":0,"blurHeight":0};